import { Field } from "./Field";
import Big from "big.js";
export class BigField extends Field {
    constructor(type, property) {
        super(type.getBytes(), property);
        this.type = type;
    }
    static forType(type, property) {
        return new BigField(type, property);
    }
    decode(b, offset) {
        const bn = this.type.getLayout().decode(b, offset);
        const big = new Big(bn.toString());
        const multiplier = this.type.getMultiplier();
        if (!multiplier) {
            return big;
        }
        return big.div(multiplier);
    }
}
//# sourceMappingURL=BigField.js.map